import React from 'react';

import { Icon, Space, Typography } from '@sravni/react-design-system';
import { Bank, Flashlight, Shield } from '@sravni/react-icons';

import { TSideBlockProps } from '../../index';

interface IProps extends Pick<TSideBlockProps, 'namesType'> {}

export const HowWeWork: React.FC<IProps> = ({ namesType }) => {
  const listData = [
    {
      icon: <Shield />,
      text: 'Отзыв проходит модерацию',
    },
    {
      icon: <Bank />,
      text: `Представитель ${namesType.mode} отвечает на отзыв`,
    },
    {
      icon: <Flashlight />,
      text: 'Решение проблемы на сайте',
    },
  ];

  return (
    <div>
      <Typography.Text strong className={'h-mb-20'}>
        Как мы работаем с отзывами
      </Typography.Text>
      <Space direction={'vertical'} size={12}>
        {listData.map((item, i) => (
          <Space key={`info-item-${i}`} size={12} align={'center'}>
            <Icon icon={item.icon} />
            <div>{item.text}</div>
          </Space>
        ))}
      </Space>
    </div>
  );
};
